(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !window.DesignMode) return;
  try {
    
  if (document.currentScript) {
    document.currentScript.setAttribute('defer', '');
  }

  document.addEventListener('DOMContentLoaded', function(){
    const ACTIVE_INDICATOR_IMG = 'https://cdn.shopify.com/s/files/1/0927/2734/5442/files/botao_redondo_navegacao_contorno_branco.png?v=1740681643';
    const INACTIVE_INDICATOR_IMG = 'https://cdn.shopify.com/s/files/1/0927/2734/5442/files/botao_redondo_navegacao_branco.png?v=1740681644';
    const AUTO_ROTATE_INTERVAL = 8000;

    // Função para ativar a redução de movimento se o usuário tiver essa preferência
    function checkReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setupRotator(rotatorId) {
      const container = document.getElementById(rotatorId);
      if (!container) return;

      const items = container.querySelectorAll('.rotator-item');
      const indicators = container.querySelectorAll('.indicator');
      const leftArrow = container.querySelector('.left-arrow');
      const rightArrow = container.querySelector('.right-arrow');
      let currentIndex = 0;
      let timer;
      let isAnimating = false;

      function updateRotator(newIndex) {
        if (isAnimating || newIndex === currentIndex) return;
        isAnimating = true;

        // Esconder slide atual
        const currentSlide = items[currentIndex];
        currentSlide.style.opacity = '0';
        currentSlide.classList.remove('active');
        currentSlide.setAttribute('aria-hidden', 'true');

        // Mostrar novo slide
        const nextSlide = items[newIndex];
        nextSlide.style.opacity = '0';
        nextSlide.classList.add('active');
        nextSlide.style.display = 'block';
        nextSlide.removeAttribute('aria-hidden');

        // Atualizar indicadores
        indicators[currentIndex].setAttribute('aria-selected', 'false');
        indicators[currentIndex].querySelector('img').src = INACTIVE_INDICATOR_IMG;
        indicators[newIndex].setAttribute('aria-selected', 'true');
        indicators[newIndex].querySelector('img').src = ACTIVE_INDICATOR_IMG;

        // Animar transição
        requestAnimationFrame(() => {
          nextSlide.style.opacity = '1';

          setTimeout(() => {
            currentSlide.style.display = 'none';
            isAnimating = false;
          }, 300);
        });

        currentIndex = newIndex;
      }

      function startAutoRotation() {
        clearInterval(timer);
        timer = setInterval(() => {
          const nextIndex = (currentIndex + 1) % items.length;
          updateRotator(nextIndex);
        }, AUTO_ROTATE_INTERVAL);
      }

      function handleNavigation(direction) {
        const nextIndex = direction === 'next'
          ? (currentIndex + 1) % items.length
          : (currentIndex - 1 + items.length) % items.length;

        updateRotator(nextIndex);
        clearInterval(timer);
        startAutoRotation();
      }

      // Event Listeners
      leftArrow?.addEventListener('click', () => handleNavigation('prev'));
      rightArrow?.addEventListener('click', () => handleNavigation('next'));

      indicators.forEach((indicator) => {
        indicator.addEventListener('click', (e) => {
          const newIndex = parseInt(e.currentTarget.dataset.index);
          updateRotator(newIndex);
          clearInterval(timer);
          startAutoRotation();
        });
      });

      // Pausar/retomar rotação automática
      container.addEventListener('mouseenter', () => clearInterval(timer));
      container.addEventListener('mouseleave', startAutoRotation);
      container.addEventListener('focusin', () => clearInterval(timer));
      container.addEventListener('focusout', (e) => {
        if (!container.contains(e.relatedTarget)) {
          startAutoRotation();
        }
      });

      // Inicializar
      items[0].classList.add('active');
      startAutoRotation();
    }

    // Usar requestAnimationFrame e Intersection Observer para melhorar performance
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => {
              setupRotator(entry.target.id);
            });
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      const rotators = document.querySelectorAll('.rotator-container');
      rotators.forEach(rotator => {
        observer.observe(rotator);
      });
    } else {
      // Fallback para navegadores que não suportam Intersection Observer
      requestAnimationFrame(() => {
        setupRotator('rotator-blog-1');
        setupRotator('rotator-blog-2');
      });
    }

    // Adicionar suporte para navegação por teclado global
    document.addEventListener('keydown', function(event) {
      // Encontrar qual carousel está atualmente em foco
      const activeElement = document.activeElement;
      let targetRotator = null;

      if (activeElement) {
        // Verificar se o elemento ativo está dentro de um rotator
        const closestRotator = activeElement.closest('.rotator-container');
        if (closestRotator) {
          targetRotator = closestRotator;
        }
      }

      if (targetRotator) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          const leftArrow = targetRotator.querySelector('.rotator-arrow.left-arrow');
          leftArrow?.click();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          const rightArrow = targetRotator.querySelector('.rotator-arrow.right-arrow');
          rightArrow?.click();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvv_quemsomos"] && !window.DesignMode) return;
  try {
    
  (function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
      initMVVSection();
    });

    function initMVVSection() {
      const mvvItems = document.querySelectorAll('.js-mvv-item');

      if (! mvvItems.length) return;
      

      animateItemsOnScroll(mvvItems);

      mvvItems.forEach(function(item) {
        item.addEventListener('mouseenter', handleItemHover);
        item.addEventListener('mouseleave', handleItemLeave);
      });
    }

    function animateItemsOnScroll(items) {
      if (!('IntersectionObserver' in window)) return;
      

      const observerOptions = {
        root: null,
        threshold: 0.2,
        rootMargin: '0px'
      };

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry, index) {
          if (entry.isIntersecting) {
            setTimeout(function() {
              entry.target.classList.add('is-visible');
            }, index * 150);

            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      items.forEach(function(item) {
        observer.observe(item);
      });
    }

    function handleItemHover(e) {
      const item = e.currentTarget;
      item.classList.add('is-active');
    }

    function handleItemLeave(e) {
      const item = e.currentTarget;
      item.classList.remove('is-active');
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
